import { FieldDependencyRules } from "@/Utils/Rules/FieldDependencyRules";

export function applyDropdownRules(
  formName,
  changedField,
  values,
  setValue,
  schemaFlat
) {
  FieldDependencyRules.forEach((rule) => {
    if (
      !rule.form &&
      !formName?.toLowerCase().includes(rule.form.toLowerCase())
    ) {
      return;
    }

    if (!rule.dependsOn.includes(changedField)) {
      console.log(
        `  Skipping rule because changed field ${changedField} not in dependsOn `
      );
      return;
    }

    const result = rule.formula(values);

    if (Array.isArray(result)) {
      const targetField = schemaFlat.find((f) => f.name === rule.target);
      if (targetField) {
        targetField.options = result;
        console.log(` Updated dropdown: ${rule.target} →`, result);
        setValue(rule.target, "", { shouldValidate: true });
      } else {
        console.warn(` Target field "${rule.target}" not found in schemaFlat`);
      }
    } else if (typeof result === "object" && result !== null) {
      const targetField = schemaFlat.find((f) => f.name === rule.target);

      if (targetField) {
        Object.assign(targetField, result);
        console.log(` Updated field properties for ${rule.target}:`, result);

        if (result?.disabled && setValue) {
          setValue(rule.target, "", { shouldValidate: false }); 
        }
      } else {
        console.warn(
          `⚠️ Target field "${rule.target}" not found in schemaFlat`
        );
      }
    } else if (rule.property === "setQueryParams") {
      const targetField = schemaFlat.find((f) => f.name === rule.target);
      console.log(result,"result check")
      const params = result || {};
      targetField.queryParams = params;
    } else {
      console.log(
        ` Formula returned non-array result for ${rule.target}:`,
        result
      );
    }
  });
}
